import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ErrorStateMatcher} from "@angular/material/core";
import {User} from "../models/User";
import {Router} from "@angular/router";
import {AuthenticationService} from "../services/authentication.service";
import {first} from "rxjs";
import Swal from "sweetalert2";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  loading = false;
  submitted = false;
  loginError: string | null = null;
  currentUser: User;
  passwordErrorStateMatcher: ErrorStateMatcher;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar
  ) {
    this.currentUser = {} as User;
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x || {} as User);
    this.passwordErrorStateMatcher = {isErrorState: () => !!this.loginError};
  }

  get f() {
    return this.loginForm.controls;
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

    this.loginForm.valueChanges.subscribe(() => {
      if (this.loginError) {
        this.loginError = null;
        this.cdRef.detectChanges();
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    this.loginError = null;
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;

    this.authenticationService.login(this.f['email'].value, this.f['password'].value)
      .pipe(first())
      .subscribe(
        () => {
          this.loading = false;
          this.loginError = null;
          this.cdRef.detectChanges();
          this.snackBar.open('We\'ve sent a secure code to your email. Enter it below to continue.', 'Close', { duration: 3000 });
          this.router.navigate(['/secure-code'], { queryParams: { email: this.f['email'].value } });
        },
        (error: any) => {
          this.loading = false;

          if (error?.status === 401) {
            this.loginError = error?.error?.error || 'Email or password is incorrect.';
            this.cdRef.detectChanges();
            return;
          }

          const errorMessage = error?.error?.error || 'An unexpected error occurred. Please try again.';
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          }).then(() => {
            this.cdRef.detectChanges();
          });
        }
      );
  }
}
